import { useCallback } from "react";
import useModalStore from "../zustand/store/useModalStore";

/**
 * @useConfirm confirm hook
 -- useConfirm hook import 후 confirm이 필요한 함수쪽에 아래 내용 붙여넣기
        const ok = await confirm('로그아웃 하시겠습니까?');
        if(!ok) return false;
 <sample>  
    import useConfirm from '../hooks/useConfirm';

    const confirm = useConfirm();

    const logout = async () => {
        const ok = await confirm('로그아웃 하시겠습니까?');
        if(!ok) return false;

        localStorage.clear();
        navigation("/member/login.do", { state: {pathname
            ,isLogout : true
        } });

        setClickedCategory('');
        toastModalOpen("로그아웃 되었습니다.");
    };
 */

export default function useConfirm() {
    const showConfirmModal = useModalStore(state => state.showConfirmModal);

    return useCallback((message, options) => showConfirmModal(message, options), [showConfirmModal]);
}